/* eslint-disable max-lines */
import Add from './Add.js';
import AddV2 from './AddV2.js';
import ArtificialIntel from './ArtificialIntel.js';
import ArtificialIntelBold from './ArtificialIntelBold.js';
import AlertsSolid from './AlertsSolid.js';
import Annotation from './Annotation.js';
import AreaActive from './AreaActive.js';
import ArrowblockE from './ArrowblockE.js';
import ArrowblockEW from './ArrowblockEW.js';
import ArrowblockN from './ArrowblockN.js';
import ArrowblockNS from './ArrowblockNS.js';
import ArrowblockNe from './ArrowblockNe.js';
import ArrowblockNe13 from './ArrowblockNe13.js';
import ArrowblockNw from './ArrowblockNw.js';
import ArrowblockS from './ArrowblockS.js';
import ArrowblockSw from './ArrowblockSw.js';
import ArrowblockW from './ArrowblockW.js';
import ArrowblockNESW from './ArrowblockNESW.js';
import ArrowblockSENW from './ArrowblockSENW.js';
import ArrowheadDown from './ArrowheadDown.js';
import ArrowheadLeft from './ArrowheadLeft.js';
import ArrowheadRight from './ArrowheadRight.js';
import ArrowheadUp from './ArrowheadUp.js';
import ArrowLeft from './ArrowLeft.js';
import ArrowReorderDown from './ArrowReorderDown.js';
import ArrowReorderUp from './ArrowReorderUp.js';
import ArrowRight from './ArrowRight.js';
import ArrowShortLeft from './ArrowShortLeft.js';
import ArrowShortReturn from './ArrowShortReturn.js';
import ArrowShortRight from './ArrowShortRight.js';
import AssetManagement from './AssetManagement.js';
import Asterisk from './Asterisk.js';
import AutoAction from './AutoAction.js';
import Avatar from './Avatar.js';
import Bar from './Bar.js';
import BarStacked from './BarStacked.js';
import Bookmark from './Bookmark.js';
import CalculationOptions from './CalculationOptions.js';
import CalculatorSimple from './CalculatorSimple.js';
import Camera from './Camera.js';
import Certificate from './Certificate.js';
import Checkmark from './Checkmark.js';
import CheckmarkCircle from './CheckmarkCircle.js';
import CheckmarkCircleFill from './CheckmarkCircleFill.js';
import CheckmarkCircleGreen from './CheckmarkCircleGreen.js';
import CheckmarkSeal from './CheckmarkSeal.js';
import CheckmarkXsmall from './CheckmarkXsmall.js';
import ChevronDown from './ChevronDown.js';
import ChevronLeft from './ChevronLeft.js';
import ChevronRight from './ChevronRight.js';
import ChevronSmallDown from './ChevronSmallDown.js';
import ChevronSmallLeft from './ChevronSmallLeft.js';
import ChevronSmallRight from './ChevronSmallRight.js';
import ChevronSmallUp from './ChevronSmallUp.js';
import ChevronUp from './ChevronUp.js';
import Close from './Close.js';
import CloseCircle from './CloseCircle.js';
import CloseMedium from './CloseMedium.js';
import CloseSmall from './CloseSmall.js';
import CloseXsmall from './CloseXsmall.js';
import Coborrower from './Coborrower.js';
import CollapseAll from './CollapseAll.js';
import Column from './Column.js';
import ColumnStacked from './ColumnStacked.js';
import Comments from './Comments.js';
import Comments2 from './Comments2.js';
import CommentsAdd from './CommentsAdd.js';
import CommentsUnread from './CommentsUnread.js';
import Conditions from './Conditions.js';
import ConditionsPopout from './ConditionsPopout.js';
import ConnectApp from './ConnectApp.js';
import Contacts from './Contacts.js';
import ContactsXsmall from './ContactsXsmall.js';
import CredentialsSolid from './CredentialsSolid.js';
import CreditReport from './CreditReport.js';
import CreditReport2 from './CreditReport2.js';
import CreditReportSolid from './CreditReportSolid.js';
import Crop from './Crop.js';
import Dashboard from './Dashboard.js';
import DataSource from './DataSource.js';
import DatePicker from './DatePicker.js';
import DatePicker2 from './DatePicker2.js';
import Delete from './Delete.js';
import Demographics from './Demographics.js';
import DeviceDesktop from './DeviceDesktop.js';
import DeviceMobile from './DeviceMobile.js';
import DeviceTablet from './DeviceTablet.js';
import DocCopy from './DocCopy.js';
import DocMove from './DocMove.js';
import Documents from './Documents.js';
import DocumentModifiedIcon from './DocumentModifiedIcon.js';
import DocumentRemoveIcon from './DocumentRemovedIcon.js';
import DocumentsView from './DocumentsView.js';
import Download from './Download.js';
import EditDocument from './EditDocument.js';
import EditPencil from './EditPencil.js';
import EducationCap from './EducationCap.js';
import EqualSign from './EqualSign.js';
import ErrorHexegon from './ErrorHexegon.js';
import ExclamationPoint from './ExclamationPoint.js';
import Excluded from './Excluded.js';
import ExlamationPointSmall from './ExlamationPointSmall.js';
import ExpandAll from './ExpandAll.js';
import ExpandDiagonal from './ExpandDiagonal.js';
import ExportCsv from './ExportCsv.js';
import ExportExcel from './ExportExcel.js';
import ExportGeneric from './ExportGeneric.js';
import Fees from './Fees.js';
import FeesSolid from './FeesSolid.js';
import File from './File.js';
import FileJpeg from './FileJpeg.js';
import FilePdf from './FilePdf.js';
import Filter from './Filter.js';
import Flag from './Flag.js';
import FlagSolid from './FlagSolid.js';
import Folder from './Folder.js';
import FolderPopout from './FolderPopout.js';
import Form1003 from './Form1003.js';
import Forms from './Forms.js';
import Gift from './Gift.js';
import Globe from './Globe.js';
import GovernmentMonitoringSolid from './GovernmentMonitoringSolid.js';
import GripperVertical from './GripperVertical.js';
import GridView from './GridView.js';
import Help from './Help.js';
import HelpCircle from './HelpCircle.js';
import HelpCircleSmall from './HelpCircleSmall.js';
import IconUserRole from './IconUserRole.js';
import Image from './Image.js';
import ImageMissing from './ImageMissing.js';
import Inbox from './Inbox.js';
import InboxOutline from './InboxOutline.js';
import InboxNew from './InboxNew.js';
import InboxNewOutline from './InboxNewOutline.js';
import InfoCircle from './InfoCircle.js';
import InfoCircleFill from './InfoCircleFill.js';
import InfoCircleFillSmall from './InfoCircleFillSmall.js';
import InfoCircleSmall from './InfoCircleSmall.js';
import InvisibleHide from './InvisibleHide.js';
import Leads from './Leads.js';
import Link from './Link.js';
import LoanFileBlank from './LoanFileBlank.js';
import LoanFileDefault from './LoanFileDefault.js';
import LoanFileFavorites from './LoanFileFavorites.js';
import LoanFileFavoritesStar from './LoanFileFavoritesStar.js';
import LoanFileInfo from './LoanFileInfo.js';
import LoanFileLocked from './LoanFileLocked.js';
import LoanPackage from './LoanPackage.js';
import LoanProducts from './LoanProducts.js';
import LoanProducts2 from './LoanProducts2.js';
import LoanProductsSolid from './LoanProductsSolid.js';
import LoanProductsTag from './LoanProductsTag.js';
import LocationPin from './LocationPin.js';
import LockCancelled from './LockCancelled.js';
import LockCancelledNewLockReq from './LockCancelledNewLockReq.js';
import LockedExtensionRequested from './LockedExtensionRequested.js';
import LockExpired from './LockExpired.js';
import LockLocked from './LockLocked.js';
import LockLockedNewLockRequested from './LockLockedNewLockRequested.js';
import LockLockedNewLockRequested2 from './LockLockedNewLockRequested2.js';
import LockLockedRateRequested from './LockLockedRateRequested.js';
import LockLockedSolid from './LockLockedSolid.js';
import LockOutline from './LockOutline.js';
import LockUnlocked from './LockUnlocked.js';
import LockUnlockedRateRequested from './LockUnlockedRateRequested.js';
import LockUnlockedSolid from './LockUnlockedSolid.js';
import LoginClient from './LoginClient.js';
import LoginUser from './LoginUser.js';
import LoginUser2 from './LoginUser2.js';
import LoginUserSolid from './LoginUserSolid.js';
import LogoEnc from './LogoEnc.js';
import LogoEncBug from './LogoEncBug.js';
import Medal from './Medal.js';
import Menu from './Menu.js';
import MenuCollapse from './MenuCollapse.js';
import MenuExpand from './MenuExpand.js';
import MenuPicker from './MenuPicker.js';
import MenuPickerSmall from './MenuPickerSmall.js';
import Messages from './Messages.js';
import MessageSolid from './MessageSolid.js';
import MessagesUnread from './MessagesUnread.js';
import MinusCircle from './MinusCircle.js';
import MinusCircleMed from './MinusCircleMed.js';
import MinusCircleSmall from './MinusCircleSmall.js';
import Modified from './Modified.js';
import MoreOptionsHorz from './MoreOptionsHorz.js';
import MoreOptionsVert from './MoreOptionsVert.js';
import MoveToFolder from './MoveToFolder.js';
import MoviePlay from './MoviePlay.js';
import NavServices from './NavServices.js';
import Notifications from './Notifications.js';
import NotifyUser from './NotifyUser.js';
import NotifyUser2 from './NotifyUser2.js';
import OpenPanel from './OpenPanel.js';
import OpenWindow from './OpenWindow.js';
import Opportunities from './Opportunities.js';
import Organization from './Organization.js';
import Overflow from './Overflow.js';
import PanelCloseComments from './PanelCloseComments.js';
import PanelCloseDetails from './PanelCloseDetails.js';
import PanelGripper from './PanelGripper.js';
import PanelOpenComments from './PanelOpenComments.js';
import PanelOpenDetails from './PanelOpenDetails.js';
import PanelOpenLeft from './PanelOpenLeft.js';
import PanelOpenRight from './PanelOpenRight.js';
import PaperAirplane from './PaperAirplane.js';
import Paperclip from './Paperclip.js';
import ParenthesisAdd from './ParenthesisAdd.js';
import ParenthesisRemove from './ParenthesisRemove.js';
import PartnerPortal from './PartnerPortal.js';
import Password from './Password.js';
import PercentSquare from './PercentSquare.js';
import Phone from './Phone.js';
import PhoneOutline from './PhoneOutline.js';
import PhoneOutlineSmall from './PhoneOutlineSmall.js';
import PhoneSmall from './PhoneSmall.js';
import Pie from './Pie.js';
import Pipeline from './Pipeline.js';
import PlusCircle from './PlusCircle.js';
import PlusCircleMedium from './PlusCircleMedium.js';
import PlusCircleSmall from './PlusCircleSmall.js';
import Print from './Print.js';
import Property from './Property.js';
import PropertySolid from './PropertySolid.js';
import QuerryAdd from './QuerryAdd.js';
import QuerryRemove from './QuerryRemove.js';
import QueryAdd from './QueryAdd.js';
import QueryRemove from './QueryRemove.js';
import RecentDocuments from './RecentDocuments.js';
import RecentItems from './RecentItems.js';
import Reciept from './Reciept.js';
import Redo from './Redo.js';
import Redo2 from './Redo2.js';
import Refresh from './Refresh.js';
import ReleaseNotes from './ReleaseNotes.js';
import Removed from './Removed.js';
import Reply from './Reply.js';
import Result from './Result.js';
import Return from './Return.js';
import RootDirectory from './RootDirectory.js';
import Run from './Run.js';
import Save from './Save.js';
import Search from './Search.js';
import SearchBar from './SearchBar.js';
import SearchSmall from './SearchSmall.js';
import SearchXsmall from './SearchXsmall.js';
import Settings from './Settings.js';
import Share from './Share.js';
import Snooze from './Snooze.js';
import SnoozeXsmall from './SnoozeXsmall.js';
import Sort from './Sort.js';
import SortAlphaAsc from './SortAlphaAsc.js';
import SortAlphaDesc from './SortAlphaDesc.js';
import SortNeutral from './SortNeutral.js';
import Star from './Star.js';
import StarEmpty from './StarEmpty.js';
import Status from './Status.js';
import StatusCheck from './StatusCheck.js';
import Subtract from './Subtract.js';
import SubtractV2 from './SubtractV2.js';
import Summary from './Summary.js';
import Tasks from './Tasks.js';
import TaskGroupIcon from './TaskGroupIcon.js';
import TechSupports from './TechSupports.js';
import TextFormat from './TextFormat.js';
import TextFormatAlt from './TextFormatAlt.js';
import TextStyleBold from './TextStyleBold.js';
import TextStyleItalic from './TextStyleItalic.js';
import TextStyleText from './TextStyleText.js';
import ThumbsDown from './ThumbsDown.js';
import ThumbsUp from './ThumbsUp.js';
import TimerClock from './TimerClock.js';
import Tools from './Tools.js';
import Transactions from './Transactions.js';
import Undo from './Undo.js';
import Undo2 from './Undo2.js';
import Unlink from './Unlink.js';
import UploadFile from './UploadFile.js';
import UserCompany from './UserCompany.js';
import ViewContract from './ViewContract.js';
import ViewDoublePane from './ViewDoublePane.js';
import ViewExpand from './ViewExpand.js';
import ViewSinglePane from './ViewSinglePane.js';
import VisibleView from './VisibleView.js';
import VisibleViewXsmall from './VisibleViewXsmall.js';
import WarningCircle from './WarningCircle.js';
import WarningCircleFill from './WarningCircleFill.js';
import WarningCircleFillSmall from './WarningCircleFillSmall.js';
import WarningCircleSmall from './WarningCircleSmall.js';
import WarningTriangle from './WarningTriangle.js';
import WarningSquare from './WarningSquare.js';
import WarningSquareOutline from './WarningSquareOutline.js';

// V2
import AlertsDetail from './AlertsDetail.js';
import AlertsDetailFill from './AlertsDetailFill.js';
import AlertsSmallFill from './AlertsSmallFill.js';
import ExceptionsDetail from './ExceptionsDetail.js';
import ExceptionsDetailFill from './ExceptionsDetailFill.js';
import ExceptionsSmallFill from './ExceptionsSmallFill.js';
import MessagesDetail from './MessagesDetail.js';
import MessagesDetailFill from './MessagesDetailFill.js';
import MessagesSmallFill from './MessagesSmallFill.js';
import Call from './Call.js';
import CreateLoan from './CreateLoan.js';
import CreateOpportunity from './CreateOpportunity.js';
import Email from './Email.js';
import InviteToApply from './InviteToApply.js';
import LogActivity from './LogActivity.js';
import ChevronDoubleLeft from './ChevronDoubleLeft.js';
import ChevronDoubleRight from './ChevronDoubleRight.js';
import FolderRoot from './FolderRoot.js';
import ClearCircleSmall from './ClearCircleSmall.js';
import Archive from './Archive.js';
import Documents2 from './Documents2.js';
import ExportExport from './ExportExport.js';
import Forms2 from './Forms2.js';
import ImportExport from './ImportExport.js';
import InProgress from './InProgress.js';
import SuccessFill from './SuccessFill.js';
import InfoFill from './InfoFill.js';
import CloseX from './CloseX.js';
import Communications from './Communications.js';

// Icons V2
import IceBlackCube from './IceBlackCube.js';
import IceBlackTagline from './IceBlackTagline.js';
import IceBlackLogo from './IceBlackLogo.js';
import IceColorCube from './IceColorCube.js';
import IceColorTagline from './IceColorTagline.js';
import IceColorLogo from './IceColorLogo.js';
import IceReverseCube from './IceReverseCube.js';
import IceReverseTagline from './IceReverseTagline.js';
import IceReverseLogo from './IceReverseLogo.js';
import IceWhiteCube from './IceWhiteCube.js';
import IceWhiteTagline from './IceWhiteTagline.js';
import IceWhiteLogo from './IceWhiteLogo.js';
import AIQIceBlue from './AIQIceBlue.js';
import AIQJetBlack from './AIQJetBlack.js';
import AIQWhite from './AIQWhite.js';
import AIQDarkIceBlue from './AIQDarkIceBlue.js';
import AIQDarkWhite from './AIQDarkWhite.js';
import AIQLightIceBlue from './AIQLightIceBlue.js';
import AIQLightJetBlack from './AIQLightJetBlack.js';
import AllRegsIceBlue from './AllRegsIceBlue.js';
import AllRegsJetBlack from './AllRegsJetBlack.js';
import AllRegsWhite from './AllRegsWhite.js';
import AllRegsDarkIceBlue from './AllRegsDarkIceBlue.js';
import AllRegsDarkWhite from './AllRegsDarkWhite.js';
import AllRegsLightIceBlue from './AllRegsLightIceBlue.js';
import AllRegsLightJetBlack from './AllRegsLightJetBlack.js';
import ENCIceBlue from './ENCIceBlue.js';
import ENCJetBlack from './ENCJetBlack.js';
import ENCWhite from './ENCWhite.js';
import ENCDarkIceBlue from './ENCDarkIceBlue.js';
import ENCDarkWhite from './ENCDarkWhite.js';
import ENCLightIceBlue from './ENCLightIceBlue.js';
import ENCLightJetBlack from './ENCLightJetBlack.js';
import InsightsIceBlue from './InsightsIceBlue.js';
import InsightsJetBlack from './InsightsJetBlack.js';
import InsightsWhite from './InsightsWhite.js';
import InsightsDarkIceBlue from './InsightsDarkIceBlue.js';
import InsightsDarkWhite from './InsightsDarkWhite.js';
import InsightsLightIceBlue from './InsightsLightIceBlue.js';
import InsightsLightJetBlack from './InsightsLightJetBlack.js';
import MarketplaceIceBlue from './MarketplaceIceBlue.js';
import MarketplaceJetBlack from './MarketplaceJetBlack.js';
import MarketplaceWhite from './MarketplaceWhite.js';
import MarketplaceDarkIceBlue from './MarketplaceDarkIceBlue.js';
import MarketplaceDarkWhite from './MarketplaceDarkWhite.js';
import MarketplaceLightIceBlue from './MarketplaceLightIceBlue.js';
import MarketplaceLightJetBlack from './MarketplaceLightJetBlack.js';
import MaventIceBlue from './MaventIceBlue.js';
import MaventJetBlack from './MaventJetBlack.js';
import MaventWhite from './MaventWhite.js';
import MaventDarkIceBlue from './MaventDarkIceBlue.js';
import MaventDarkWhite from './MaventDarkWhite.js';
import MaventLightIceBlue from './MaventLightIceBlue.js';
import MaventLightJetBlack from './MaventLightJetBlack.js';
import SimplifileIceBlue from './SimplifileIceBlue.js';
import SimplifileJetBlack from './SimplifileJetBlack.js';
import SimplifileWhite from './SimplifileWhite.js';
import SimplifileDarkIceBlue from './SimplifileDarkIceBlue.js';
import SimplifileDarkWhite from './SimplifileDarkWhite.js';
import SimplifileLightIceBlue from './SimplifileLightIceBlue.js';
import SimplifileLightJetBlack from './SimplifileLightJetBlack.js';
import VelocifyIceBlue from './VelocifyIceBlue.js';
import VelocifyJetBlack from './VelocifyJetBlack.js';
import VelocifyWhite from './VelocifyWhite.js';
import VelocifyDarkIceBlue from './VelocifyDarkIceBlue.js';
import VelocifyDarkWhite from './VelocifyDarkWhite.js';
import VelocifyLightIceBlue from './VelocifyLightIceBlue.js';
import VelocifyLightJetBlack from './VelocifyLightJetBlack.js';
import VerifiyLrg from './VerifiyLrg.js';
import VerifiySml from './VerifiySml.js';
import IceBlackHorizontalPowerBy from './IceBlackHorizontalPowerBy.js';
import IceBlackVerticalPowerBy from './IceBlackVerticalPowerBy.js';
import IceWhiteHorizontalPowerBy from './IceWhiteHorizontalPowerBy.js';
import IceWhiteVerticalPowerBy from './IceWhiteVerticalPowerBy.js';
import FormsCustom from './FormsCustom.js';
import ToolsCustom from './ToolsCustom.js';
import QuickOrder from './QuickOrder.js';
import CloseCircleFillMed from './CloseCircleFillMed.js';
import ArrowCircleLeft from './ArrowCircleLeft.js';
import ArrowCircleRight from './ArrowCircleRight.js';
import ApplicantsAssociation from './ApplicantsAssociation.js';
import DataInspect from './DataInspect.js';
import DataMapper from './DataMapper.js';
import SettingsOutline from './SettingsOutline.js';
import QueryAdd2 from './QueryAdd2.js';
import QueryRemove2 from './QueryRemove2.js';
import FolderGroup from './FolderGroup.js';
import Assets from './Assets.js';
import AuditLog from './AuditLog.js';
import Aus from './Aus.js';
import Collateral from './Collateral.js';
import Credit2 from './Credit2.js';
import FileDocs from './FileDocs.js';
import Income from './Income.js';
import Matcher from './Matcher.js';
import ViewHorzPane from './ViewHorzPane.js';
import FileV2 from './FileV2.js';
import MinusCircleFillLarge from './MinusCircleFillLarge.js';
import MinusCircleFillMedium from './MinusCircleFillMedium.js';
import MinusCircleFillSmall from './MinusCircleFillSmall.js';
import Merge from './Merge.js';
import CheckMarkCircleFillSmall from './CheckMarkCircleFillSmall.js';
import Typography from './Typography.js';
import Dropdown from './Dropdown.js';
import InputText from './InputText.js';
import InputTextArea from './InputTextArea.js';
import CompareImport from './CompareImport.js';
import DeskBell from './DeskBell.js';
import Button from './Button.js';
import Checkbox from './Checkbox.js';
import GroupBox from './GroupBox.js';
import TriangleDownSmall from './TriangleDownSmall.js';
import Paragraph from './Paragraph.js';
import RadioButton from './RadioButton.js';
import Spacer from './Spacer.js';
import TriangleUpSmall from './TriangleUpSmall.js';
import ArchiveLocked from './ArchiveLocked.js';
import CheckmarkCircleEmpty from './CheckmarkCircleEmpty.js';
import UserAssign from './UserAssign.js';
import LoanFileCopyNumber from './LoanFileCopyNumber.js';
import BusinessIntelligence from './BusinessIntelligence.js';

export { IconWithSchema } from './utils/SvgIcon.js';
export {
  ArtificialIntel,
  ArtificialIntelBold,
  Add,
  AddV2,
  AlertsSolid,
  Annotation,
  AreaActive,
  ArrowblockE,
  ArrowblockEW,
  ArrowblockN,
  ArrowblockNS,
  ArrowblockNe,
  ArrowblockNe13,
  ArrowblockNw,
  ArrowblockS,
  ArrowblockSw,
  ArrowblockW,
  ArrowblockNESW,
  ArrowblockSENW,
  ArrowheadDown,
  ArrowheadLeft,
  ArrowheadRight,
  ArrowheadUp,
  ArrowLeft,
  ArrowReorderDown,
  ArrowReorderUp,
  ArrowRight,
  ArrowShortLeft,
  ArrowShortReturn,
  ArrowShortRight,
  AssetManagement,
  Asterisk,
  AutoAction,
  Avatar,
  Bar,
  BarStacked,
  Bookmark,
  CalculationOptions,
  CalculatorSimple,
  Camera,
  Certificate,
  Checkmark,
  CheckmarkCircle,
  CheckmarkCircleFill,
  CheckmarkCircleGreen,
  CheckmarkSeal,
  CheckmarkXsmall,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronSmallDown,
  ChevronSmallLeft,
  ChevronSmallRight,
  ChevronSmallUp,
  ChevronUp,
  Close,
  CloseCircle,
  CloseMedium,
  CloseSmall,
  CloseXsmall,
  Coborrower,
  CollapseAll,
  Column,
  ColumnStacked,
  Comments,
  Comments2,
  CommentsAdd,
  CommentsUnread,
  Conditions,
  ConditionsPopout,
  ConnectApp,
  Contacts,
  ContactsXsmall,
  CredentialsSolid,
  CreditReport,
  CreditReport2,
  CreditReportSolid,
  Crop,
  Dashboard,
  DataSource,
  DatePicker,
  DatePicker2,
  Delete,
  Demographics,
  DeviceDesktop,
  DeviceMobile,
  DeviceTablet,
  DocCopy,
  DocMove,
  Documents,
  DocumentModifiedIcon,
  DocumentRemoveIcon,
  DocumentsView,
  Download,
  EditDocument,
  EditPencil,
  EducationCap,
  EqualSign,
  ErrorHexegon,
  ExclamationPoint,
  Excluded,
  ExlamationPointSmall,
  ExpandAll,
  ExpandDiagonal,
  ExportCsv,
  ExportExcel,
  ExportGeneric,
  Fees,
  FeesSolid,
  File,
  FileJpeg,
  FilePdf,
  Filter,
  Flag,
  FlagSolid,
  Folder,
  FolderPopout,
  Form1003,
  Forms,
  Gift,
  Globe,
  GovernmentMonitoringSolid,
  GripperVertical,
  GridView,
  Help,
  HelpCircle,
  HelpCircleSmall,
  IconUserRole,
  Image,
  ImageMissing,
  Inbox,
  InboxOutline,
  InboxNew,
  InboxNewOutline,
  InfoCircle,
  InfoCircleFill,
  InfoCircleFillSmall,
  InfoCircleSmall,
  InvisibleHide,
  Leads,
  Link,
  LoanFileBlank,
  LoanFileDefault,
  LoanFileFavorites,
  LoanFileFavoritesStar,
  LoanFileInfo,
  LoanFileLocked,
  LoanPackage,
  LoanProducts,
  LoanProducts2,
  LoanProductsSolid,
  LoanProductsTag,
  LocationPin,
  LockCancelled,
  LockCancelledNewLockReq,
  LockedExtensionRequested,
  LockExpired,
  LockLocked,
  LockLockedNewLockRequested,
  LockLockedNewLockRequested2,
  LockLockedRateRequested,
  LockLockedSolid,
  LockOutline,
  LockUnlocked,
  LockUnlockedRateRequested,
  LockUnlockedSolid,
  LoginClient,
  LoginUser,
  LoginUser2,
  LoginUserSolid,
  LogoEnc,
  LogoEncBug,
  Medal,
  Menu,
  MenuCollapse,
  MenuExpand,
  MenuPicker,
  MenuPickerSmall,
  Messages,
  MessageSolid,
  MessagesUnread,
  MinusCircle,
  MinusCircleMed,
  MinusCircleSmall,
  Modified,
  MoreOptionsHorz,
  MoreOptionsVert,
  MoveToFolder,
  MoviePlay,
  NavServices,
  Notifications,
  NotifyUser,
  NotifyUser2,
  OpenPanel,
  OpenWindow,
  Opportunities,
  Organization,
  Overflow,
  PanelCloseComments,
  PanelCloseDetails,
  PanelGripper,
  PanelOpenComments,
  PanelOpenDetails,
  PanelOpenLeft,
  PanelOpenRight,
  PaperAirplane,
  Paperclip,
  ParenthesisAdd,
  ParenthesisRemove,
  PartnerPortal,
  Password,
  PercentSquare,
  Phone,
  PhoneOutline,
  PhoneOutlineSmall,
  PhoneSmall,
  Pie,
  Pipeline,
  PlusCircle,
  PlusCircleMedium,
  PlusCircleSmall,
  Print,
  Property,
  PropertySolid,
  QuerryAdd,
  QuerryRemove,
  QueryAdd,
  QueryRemove,
  RecentDocuments,
  RecentItems,
  Reciept,
  Redo,
  Redo2,
  Refresh,
  ReleaseNotes,
  Removed,
  Reply,
  Result,
  Return,
  RootDirectory,
  Run,
  Save,
  Search,
  SearchBar,
  SearchSmall,
  SearchXsmall,
  Settings,
  Share,
  Snooze,
  SnoozeXsmall,
  Sort,
  SortAlphaAsc,
  SortAlphaDesc,
  SortNeutral,
  Star,
  StarEmpty,
  Status,
  StatusCheck,
  Subtract,
  SubtractV2,
  Summary,
  Tasks,
  TaskGroupIcon,
  TechSupports,
  TextFormat,
  TextFormatAlt,
  TextStyleBold,
  TextStyleItalic,
  TextStyleText,
  ThumbsDown,
  ThumbsUp,
  TimerClock,
  Tools,
  Transactions,
  Undo,
  Undo2,
  Unlink,
  UploadFile,
  UserCompany,
  ViewContract,
  ViewDoublePane,
  ViewExpand,
  ViewSinglePane,
  VisibleView,
  VisibleViewXsmall,
  WarningCircle,
  WarningCircleFill,
  WarningCircleFillSmall,
  WarningCircleSmall,
  WarningTriangle,
  WarningSquare,
  WarningSquareOutline,
  AlertsDetail,
  AlertsDetailFill,
  AlertsSmallFill,
  ExceptionsDetail,
  ExceptionsDetailFill,
  ExceptionsSmallFill,
  MessagesDetail,
  MessagesDetailFill,
  MessagesSmallFill,
  Call,
  CreateLoan,
  CreateOpportunity,
  Email,
  InviteToApply,
  LogActivity,
  ChevronDoubleLeft,
  ChevronDoubleRight,
  FolderRoot,
  ClearCircleSmall,
  Archive,
  Documents2,
  ExportExport,
  Forms2,
  ImportExport,
  InProgress,
  SuccessFill,
  InfoFill,
  CloseX,
  Communications,
  IceBlackCube,
  IceBlackTagline,
  IceBlackLogo,
  IceColorCube,
  IceColorTagline,
  IceColorLogo,
  IceReverseCube,
  IceReverseTagline,
  IceReverseLogo,
  IceWhiteCube,
  IceWhiteTagline,
  IceWhiteLogo,
  AIQIceBlue,
  AIQJetBlack,
  AIQWhite,
  AIQDarkIceBlue,
  AIQDarkWhite,
  AIQLightIceBlue,
  AIQLightJetBlack,
  AllRegsIceBlue,
  AllRegsJetBlack,
  AllRegsWhite,
  AllRegsDarkIceBlue,
  AllRegsDarkWhite,
  AllRegsLightIceBlue,
  AllRegsLightJetBlack,
  ENCIceBlue,
  ENCJetBlack,
  ENCWhite,
  ENCDarkIceBlue,
  ENCDarkWhite,
  ENCLightIceBlue,
  ENCLightJetBlack,
  InsightsIceBlue,
  InsightsJetBlack,
  InsightsWhite,
  InsightsDarkIceBlue,
  InsightsDarkWhite,
  InsightsLightIceBlue,
  InsightsLightJetBlack,
  MarketplaceIceBlue,
  MarketplaceJetBlack,
  MarketplaceWhite,
  MarketplaceDarkIceBlue,
  MarketplaceDarkWhite,
  MarketplaceLightIceBlue,
  MarketplaceLightJetBlack,
  MaventIceBlue,
  MaventJetBlack,
  MaventWhite,
  MaventDarkIceBlue,
  MaventDarkWhite,
  MaventLightIceBlue,
  MaventLightJetBlack,
  SimplifileIceBlue,
  SimplifileJetBlack,
  SimplifileWhite,
  SimplifileDarkIceBlue,
  SimplifileDarkWhite,
  SimplifileLightIceBlue,
  SimplifileLightJetBlack,
  VelocifyIceBlue,
  VelocifyJetBlack,
  VelocifyWhite,
  VelocifyDarkIceBlue,
  VelocifyDarkWhite,
  VelocifyLightIceBlue,
  VelocifyLightJetBlack,
  VerifiyLrg,
  VerifiySml,
  IceBlackHorizontalPowerBy,
  IceBlackVerticalPowerBy,
  IceWhiteHorizontalPowerBy,
  IceWhiteVerticalPowerBy,
  FormsCustom,
  ToolsCustom,
  QuickOrder,
  CloseCircleFillMed,
  ArrowCircleLeft,
  ArrowCircleRight,
  ApplicantsAssociation,
  DataInspect,
  DataMapper,
  SettingsOutline,
  QueryAdd2,
  QueryRemove2,
  FolderGroup,
  Assets,
  AuditLog,
  Aus,
  Collateral,
  Credit2,
  FileDocs,
  Income,
  Matcher,
  ViewHorzPane,
  FileV2,
  MinusCircleFillLarge,
  MinusCircleFillMedium,
  MinusCircleFillSmall,
  Merge,
  CheckMarkCircleFillSmall,
  Typography,
  Dropdown,
  InputText,
  InputTextArea,
  CompareImport,
  DeskBell,
  Button,
  Checkbox,
  GroupBox,
  TriangleDownSmall,
  Paragraph,
  RadioButton,
  Spacer,
  TriangleUpSmall,
  ArchiveLocked,
  CheckmarkCircleEmpty,
  UserAssign,
  LoanFileCopyNumber,
  BusinessIntelligence,
};

// We export icons this way to avoid duplicating export lines per icon.
export { CommentsSms } from './CommentsSms.js';
export { IceWhite } from './ICEWhite.js';
export { IceBlack } from './ICEBlack.js';
export { IceBlue } from './ICEBlue.js';
export { LockupDarkBGICEBlue } from './LockupDarkBGICEBlue.js';
export { LockupLightBGICEBlack } from './LockupLightBGICEBlack.js';
export { LockupLightBGICEBlue } from './LockupLightBGICEBlue.js';

export { xxlSizes, xlSizes, lSizes, mSizes, sSizes, xsSizes, xxsSizes, standarSizes, getSize } from './utils/styled.js';

export type { SvgIconT } from './utils/react-desc-prop-types.js';
